import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Plural } from '@lingui/react';
import { isValidMarketRegion } from '../../../../helpers/utils';

import Button, { BUTTON_STYLES } from '../../../button/button';
import ThreeEssentailsButton from '../../../three-essentails-button/three-essentails-button';
import Resources from '../../../../helpers/resources';

const SignInCardsButton = ({ isOneRosterActivatedSchool, classGroupStudents, numOfSelectedStudents, hasStudents, openModal }) => {
    const downloadOneRosterSignInCards = async () => {
        Resources.getConfigurationItem('THREE_ESSENTIALS_SIGN_IN_CARDS').then((signInUrl) => {
            const uidsQueryString = classGroupStudents
                .map(({ oneRosterUserId }) => `uids[]=${encodeURIComponent(oneRosterUserId)}`)
                .join('&');
            const fullUrl = `${signInUrl}?${uidsQueryString}`;
            window.open(fullUrl);
        });
    };

    const pluralLabel = (
        <Plural
            id="Footer - download sign-in - button title - {numOfSelectedStudents}"
            value={numOfSelectedStudents}
            _0="Download sign-in cards"
            one="Download sign-in cards (#)"
            other="Download sign-in cards (#)"
        />
    );

    if (isOneRosterActivatedSchool) {
        return (
            <Fragment>
                <ThreeEssentailsButton
                    clickHandler={downloadOneRosterSignInCards}
                    title={pluralLabel}
                    show3EIcon={isValidMarketRegion()}
                    buttonClassName={'footer-download'}
                />
            </Fragment>
        );
    }

    return (
        <Fragment>
            <Button
                buttonStyle={BUTTON_STYLES.iconText}
                iconName="download"
                isBtnDisabled={!hasStudents}
                visibleText={pluralLabel}
                importedClasses="footer__button"
                callback={openModal}
            />
        </Fragment>
    );
};

SignInCardsButton.propTypes = {
    isOneRosterActivatedSchool: PropTypes.bool.isRequired,
    classGroupStudents: PropTypes.array.isRequired,
    numOfSelectedStudents: PropTypes.number.isRequired,
    hasStudents: PropTypes.bool.isRequired,
    openModal: PropTypes.func.isRequired
};

export default SignInCardsButton;



// WEBPACK FOOTER //
// ./components/footer/components/sign-in-cards-button/sign-in-cards-button.js